import { Injectable } from '@angular/core';
import { HxCatalogService } from 'hx-services';
import { BehaviorSubject } from 'rxjs';

const FRESH_MS = 60_000;

/**
 * The number on the tab «Без карточки»: online products with a price but no card. The query reads the whole product stock, so the number is asked at most once a minute
 * and again after an action that changes it, not on every screen of the module.
 */
@Injectable({providedIn: 'root'})
export class CatalogBadgeService {
  /** `null` until the first answer (and when the question failed): the tab shows no number */
  readonly uncovered$ = new BehaviorSubject<number | null>(null);
  private askedAt = 0;

  constructor(
    private catalog: HxCatalogService,
  ) {
  }

  async refresh(force = false): Promise<void> {
    if (!force && Date.now() - this.askedAt < FRESH_MS) {
      return;
    }
    this.askedAt = Date.now();
    try {
      const count = await this.catalog.getUncoveredCount();
      this.uncovered$.next(count.count);
    } catch {
      this.askedAt = 0;
    }
  }
}
